import PropTypes from 'prop-types';
import Field from './fields/Field.js';
import { FIELD_LABEL_BY_ID } from './ThematiqueTypes.js';

const Critere = ({ critere, onUpdateValue, onRemove }) => (
  <div className="critere">
    <button
      type="button"
      className="critere-remove"
      onClick={() => onRemove(critere.id)}
    >
      &times;
    </button>
    <label htmlFor={`input-${critere.id}`} className="critere-label">
      {FIELD_LABEL_BY_ID[critere.champRecherche]}
    </label>
    <Field
      fieldId={critere.champRecherche}
      name={`input-${critere.id}`}
      defaultValue={{
        valeur: critere.valeur,
        label: critere.label,
        operateur: critere.operateur,
        ancestorLabels: critere.ancestorLabels,
      }}
      onChange={(value) => onUpdateValue(critere.id, value)}
    />
  </div>
);
Critere.propTypes = {
  critere: PropTypes.object.isRequired,
  onUpdateValue: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default Critere;
